import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { useField } from "react-final-form";
import { filter } from "lodash";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

interface RemoveSelectedUnAssignedLocationButtonProps {
  routeLocationIds: number[];
  handleResetSelectedValues: () => void;
}

const RemoveSelectedUnAssignedLocationButton: React.FC<
  RemoveSelectedUnAssignedLocationButtonProps
> = ({ routeLocationIds, handleResetSelectedValues }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedRouteLocations, setSelectedRouteLocations] = useState<any>([]);

  const droppedLocationsField = useField("droppedLocations");
  const formRoutesChangedField = useField("formRoutesChanged");

  const classes = useStyles();

  const handleOpenDialog = () => {
    const findRouteLocations = filter(
      droppedLocationsField.input.value,
      (loc: any) => routeLocationIds.includes(loc.id),
    );
    setSelectedRouteLocations(findRouteLocations);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSaveRemoveSelectedUnAssignedLocation = () => {
    droppedLocationsField.input.onChange(
      droppedLocationsField.input.value.filter(
        (loc: any) => !routeLocationIds.includes(loc.id),
      ),
    );

    setSelectedRouteLocations([]);
    formRoutesChangedField.input.onChange(true);

    handleResetSelectedValues();

    handleClose();
  };

  return (
    <>
      <Button label="Remove Selected Location" onClick={handleOpenDialog} />

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Remove Selected Unassigned Locations
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to remove this unassigned location?
          </DialogContentText>

          <ul style={{ fontWeight: 600, margin: 5 }}>
            {selectedRouteLocations.map((loc: any) => (
              <li key={loc.id}>{loc.address}</li>
            ))}
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <Button
            onClick={handleSaveRemoveSelectedUnAssignedLocation}
            color="primary"
            label="Save"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveSelectedUnAssignedLocationButton;
